<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div>
        <div class="section-title">Back Office Booking</div>
      </div>
    </div>

    <b-modal
      title="Reservation Id"
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      ref="reservation_id_popup"
      id="reservation_id_popup"
      class="seat_select_modal"
    >
      <div class="text-center pt-4">
        <h5 class="font-weight-bold text-blue mb-3">
          Please copy this Reservation Id for Unpaid Booking.
        </h5>
        <div class="d-flex justify-content-center">
          <div class="font-weight-bold fs-22">{{ reservation_id }}</div>
          <!-- <img
            @click="onCopyId(reservation_id)"
            src="@/assets/img/icons/copy_image_icon.png"
            width="15px"
            height="15px"
            class="ml-2 mt-2"
          />-->
        </div>
      </div>
    </b-modal>

    <div class="white-wrapper">
      <div class="row" style="zoom:0.9;">
        <div class="col-lg-6 col-xl-3 mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.cinema && selected.cinema.length > 0 ? 'shift-up' : ''
              "
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <multiselect
              :options="CinemasList"
              v-model="CinemaObj"
              :searchable="true"
              label="cine_name"
              track-by="cine_id"
              placeholder="Select Cinema"
              @input="onSelectCinema($event)"
              :allowEmpty="true"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="showdate"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  :disabled="dateenable"
                  ref="programaticOpen"
                  v-model="showdate"
                  name="showdate"
                  @input="onchangeStartDate"
                  id="showdate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <!-- {{showdate.length}} -->
                <label :class="typeof showdate === 'object' ? 'active' : ''"
                  >{{ $tc("show", 1) }} {{ $t("date") }}</label
                >
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('showdate')">{{
                  errors.first("showdate")
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container pr-28px">
            <label :class="selectedUser.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("user", 1) }}</label
            >
            <b-dropdown
              :text="selectedUser"
              variant="dropdown-curve"
              class="w-100"
              name="selectuser"
              id="selectuser"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search User"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchUser()"
                  v-on:keydown="onSearchUser()"
                  v-on:search="onSearchUser()"
                  v-model="searchUser"
                />
              </div>
              <b-dropdown-item
                v-for="(user, userIndex) in Users"
                :key="userIndex"
                @click="onSelectUser($event, user)"
                >{{ user.first_name }} {{ user.last_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>

          <p class="error_message">
            <span v-if="submitted && selectedUser.length == 0">{{
              messageuser
            }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-3 mb-2">
          <div class="dropdown-curve-container">
            <label :class="selected.pm_id ? 'shift-up' : ''"
              >Payment Mode</label
            >
            <multiselect
              :options="paymentModes"
              v-model="selectedPaymentMode"
              :searchable="true"
              label="pm_payment_mode"
              track-by="pm_id"
              placeholder=""
              @select="onSelectPaymentMode($event, 'select')"
              @remove="onSelectPaymentMode($event, 'remove')"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.show_time && selected.show_time.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $tc("Show", 1) }}</label
            >
            <multiselect
              :disabled="ShowTime.length == 0"
              :options="ShowTime"
              v-model="showTimeObj"
              label="movie_name"
              :searchable="true"
              track-by="ss_id"
              placeholder="Select Show"
              @input="onSelectShow($event)"
              :allowEmpty="true"
              :showLabels="false"
            ></multiselect>
          </div>

          <p class="error_message">
            <span
              v-if="submitted && selected.show_time.length == 0"
              class="error_message"
              >{{ msgshowtime }}</span
            >
          </p>
        </div>
        <div class="col-lg-3 col-md-2">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue-lg w-100"
            style="height: 40px"
          >
            Fetch Seats Details
          </button>
        </div>
        <div v-if="flag" class="col-12">
          <hr class="mt-0" />
        </div>
        <div v-if="flag" class="col-12 text-center">
          <div class="d-flex w-100 justify-content-between mb-4">
            <div class="d-flex">
              <div
                v-for="(seatType, seatTypeIndex) in seatTypes"
                :key="seatTypeIndex"
                :class="seatType.value == 1 ? 'mx-1 px-xl-3' : 'mx-1 mx-xl-3'"
              >
                <div
                  v-if="
                    (seatType.value == 5) |
                      (seatType.value == 1) |
                      (seatType.value == 12)
                  "
                  v-on:click="selectSeatType(seatType)"
                  class="pos-seat bg-blue cursor-pointer"
                >
                  <img :src="seatType.imageURL" height="28" width="28" />
                </div>
                <small
                  v-if="
                    (seatType.value == 5) |
                      (seatType.value == 1) |
                      (seatType.value == 12)
                  "
                  >{{ $tc(seatType.seatName, "1") }}</small
                >

                <div
                  v-if="
                    seatType.value != 5 &&
                    seatType.value != 1 &&
                    seatType.value != 12 &&
                    seatType.value != 8
                  "
                  class="pos-seat disabled cinema-seat bg-blue"
                >
                  <img :src="seatType.imageURL" height="28" width="28" />
                </div>
                <small
                  v-if="
                    seatType.value != 5 &&
                    seatType.value != 1 &&
                    seatType.value != 12 &&
                    seatType.value != 8
                  "
                  >{{ $tc(seatType.seatName, "1") }}</small
                >
                <div v-if="seatType.value == 8" class="mx-1">
                  <div
                    class="pos-seat my-0 taken seat-fixed-width mx-auto"
                  ></div>
                  <small>{{ $t("taken") }}</small>
                </div>
              </div>
            </div>
          </div>
          <h5>All eyes this way.</h5>

          <div class="col-12">
            <div
              class="pos-seatlayout mb-3"
              style="height: 100%; max-height: 70vh"
            >
              <table
                v-for="(seat, seatIndex) in seatType"
                :key="seatIndex"
                class="mb-2"
              >
                <!-- SLIVER CLASS LABEL -->
                <tr>
                  <td colspan="22">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      <b-form-checkbox
                        class="j-checkbox pb-0"
                        name="check-button"
                        value="Y"
                        unchecked-value="N"
                        @change="onSelectAllSeats($event, seat, seatIndex)"
                      ></b-form-checkbox>
                      <div class="font-weight-bold">{{ seat.seatType }}</div>
                    </div>
                  </td>
                </tr>

                <tr
                  v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
                  :key="seatRowIndex"
                >
                  <td
                    v-for="(singleSeat, singleSeatIndex) in seatRow"
                    :key="'index' + singleSeatIndex"
                  >
                    <div v-if="singleSeat.srt_id == 2" class="pos-seatNumber">
                      {{ singleSeat.sl_seat_name }}
                    </div>
                    <div v-else class="pos-seatNumber">
                      {{ singleSeat.sl_seat_name }}
                    </div>
                    <!-- {{singleSeat.seat_reserve_type_id}} -->
                    <div
                      v-on:click="
                        onClickSeat(
                          singleSeat,
                          seatRowIndex,
                          singleSeatIndex,
                          null,
                          null,
                          $event,
                          seatIndex
                        )
                      "
                      class="pos-seat cursor-pointer"
                      :style="{
                        borderColor:
                          singleSeat.selectStatus == true
                            ? '#01d04a !important'
                            : singleSeat.seat_reserve_type_id == 8
                            ? checkSeatPriortyColor(singleSeat)
                            : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                                .sst_seat_color_code + ' !important',
                        backgroundColor:
                          singleSeat.selectStatus == true
                            ? ''
                            : singleSeat.seat_reserve_type_id == 8
                            ? checkSeatPriortyColor(singleSeat)
                            : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                                .sst_seat_color_code + ' !important',
                      }"
                      :class="
                        !singleSeat.selectStatus
                          ? singleSeat.isVipReserved
                            ? 'reserved-seat taken pointer-events'
                            : singleSeat.srt_id == 2
                            ? 'normal-seat pointer-events'
                            : singleSeat.seat_reserve_type_id == 8
                            ? 'pointer-events'
                            : singleSeat.seat_reserve_type_id == 13
                            ? 'pointer-events'
                            : ''
                          : ''
                      "
                    >
                      <img
                        v-if="!checkSeatPriortyColor(singleSeat)"
                        :src="getSeatIconURL(singleSeat)"
                        height="28"
                        width="28"
                      />
                    </div>
                  </td>
                </tr>
              </table>
            </div>
             <div v-if="seatBookedSummmary.length" class="w-100 d-flex justify-content-center align-items-center">
                  <div class="channel-box" v-for="(channel, channelIndex) in seatBookedSummmary" :key="channelIndex">
                    <div class="colorNote" :style="{
                      backgroundColor: channel.channel_color || ''
                    }"></div>
                    <div class="channelNote">({{channel.booking_count || 0}})</div>
                    <div class="channelNote">{{channel.channel_name}}</div>
                  </div>
                </div>
          </div>

          <button
            :disabled="btenable"
            v-if="SELECTED_SEATS.length > 0"
            @click.prevent.stop="OnSave()"
            class="btn-blue"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>

    <b-modal
      hide-footer
      hide-header
      hide-backdrop
      no-close-on-backdrop
      id="showRateCardPrice"
      ref="showRateCardPrice"
      title="Show Rate Card"
      class=""
      size="xl"
    >
      <div class="d-flex flex-column">
        <div class="d-flex border-bottom border-dark">
          <div class="col-6">
            <h5 class="font-weight-bold mt-2">Show Rate Card</h5>
          </div>
          <div class="col-6 text-right">
            <button
              class="btn-modal-close ml-auto"
              @click="$bvModal.hide('showRateCardPrice')"
            >
              &times;
            </button>
          </div>
        </div>

        <div
          class="d-flex flex-column"
          v-if="seatsSelectedRateGroupNew.length > 0"
        >
          <div
            class="d-flex align-items-center border-bottom flex-wrap"
            v-for="(item, index) in seatsSelectedRateGroupNew"
            :key="index"
          >
            <div
              class="seat-type gold"
              :style="'color:' + item.AllSeats[0].sst_seat_color_code"
            >
              <div class="st-name">{{ item.srt_name }}</div>
              <div>{{ item.totalSelected }}/{{ item.AllSeats.length }}</div>
            </div>
            <div
              class="d-flex align-items-center flex-wrap"
              v-for="(rg, rg_index) in item.rate_card_group"
              :key="rg_index"
            >
              <div class="category">
                <div class="category-name">
                  {{ rg.tt_name }}
                </div>
                <div class="category-price">
                  {{ currencyData.curr_code }} {{ rg.rc_total_amount }}
                </div>
                <div class="category-seats">
                  <div
                    class="mod-btn"
                    @click="totalCount(rg, index, rg_index, 'decrement')"
                    :class="rg.totalSeatSelected == 0 ? 'disabled' : ''"
                  >
                    -
                  </div>
                  <div>{{ rg.totalSeatSelected }}</div>
                  <div
                    class="mod-btn"
                    @click="totalCount(rg, index, rg_index, 'increment')"
                    :class="
                      item.totalSelected == item.AllSeats.length
                        ? 'disabled'
                        : ''
                    "
                  >
                    +
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-column w-100 px-4 border-bottom">
            <div
              class="d-flex w-100 justify-content-between align-items-center border-bottom"
            >
              <h5>Total Seats</h5>
              <h4 class="font-weight-bold">
                {{ totalSeatBooked }}/{{ this.SELECTED_SEATS.length }}
              </h4>
            </div>
            <div
              class="d-flex w-100 justify-content-between align-items-center py-2"
            >
              <h5>Total Price</h5>
              <h3 class="font-weight-bold">
                {{ currencyData.curr_code }} {{ totalAmountPrice }}
              </h3>
            </div>
          </div>

          <div class="py-2 d-flex">
            <h5 class="mr-3">Guest Details:</h5>

            <b-form-checkbox
              class="j-checkbox mb-1 pb-0"
              name="check-button"
              v-model="isGuestDetail"
            ></b-form-checkbox>
            <label v-if="isErrorGuest" class="text-error">{{
              ErrorGuest
            }}</label>
            &nbsp;&nbsp;
            <h5 class="mr-3">Marketing Ticket:</h5>
            <b-form-checkbox
              class="j-checkbox mb-1 pb-0"
              name="check-button"
              value="Y"
              unchecked-value="N"
              v-model="isMarketingBulkTicket"
            ></b-form-checkbox>
          </div>

          <div
            class="d-flex col-10 align-item-center justify-content-center"
            style="gap: 15px"
            v-if="isGuestDetail"
          >
            <b-form-input
              type="text"
              v-model="firstName"
              placeholder="Enter Name"
            />
            <b-form-input
              type="email"
              v-model="emailId"
              placeholder="Email Id"
            />
            <b-form-input
              type="number"
              v-model="phoneNumber"
              placeholder="Phone Number"
            />
          </div>

          <div
            class="d-flex align-items-center justify-content-center col-10 py-3"
          >
            <div class="input-material-textarea">
              <textarea v-model="Remarks"></textarea>
              <label :class="Remarks && Remarks.length > 0 ? 'shift-up' : ''">
                {{ $tc("Remarks", 2) }}
              </label>
            </div>
          </div>

          <div class="w-100 d-flex align-items-center justify-content-center">
            <button
              class="fl btn-blue my-3 h5"
              :class="
                totalSeatBooked == this.SELECTED_SEATS.length
                  ? ''
                  : 'btn-submit-disabled'
              "
              @click="reserveSeats"
            >
              Book Seat
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import scheduleService from "@/services/scheduleService";
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import PosService from "@/services/PosService";
import ExhibitorService from "@/services/ExhibitorService";
import _ from "lodash";
import Countries from "@/helper/formJSONMaster/Countries";
import { CLIENT_NAME } from "@/helper/Role";
import moment from "moment";

export default {
  data() {
    return {
      MoviesListCopy: [],
      Methods: Countries.Methods,
      country_code: "",
      guestDetailData: [],
      searchMovie: "",
      CinemasListCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: true,
      submitted: false,
      dateenable: true,
      movieenable: true,
      msgcinema: "",
      msgscreen: "",
      msgmovie: "",
      msgshowtime: "",
      messageuser: "",
      selected: {
        cinema: "",
        screen_name: "",
        movie_name: "",
        show_time: "",
        pm_id: null,
      },
      showdate: "",
      cineid: "",
      screenid: "",
      movieid: "",
      showid: "",
      turnOffMultiSeatSelection: "N",

      flag: false,
      disabledDates: {
        from: new Date(Date.now() - 8640000),
      },
      reservation_id: null,
      SetAllSeats: [],
      Seats: [],
      CinemasList: [],
      MoviesList: [],
      ScreenList: [],
      selectedMoviesInScreens: [],
      ShowTime: [],
      seatTypeSelected: {
        seatName: "regularSeat",
        size: 1,
        value: 1,
        imageClass: "regular-seat",
      },
      screenSeatTypeSelected: {},
      seatTypeSelectionMode: "seatType",
      seatTypes: [
        {
          seatName: "Regular Seat",
          size: 1,
          value: 1,
          imageClass: "regular-seat",
          imageURL: "",
        },
        {
          seatName: "No Seat",
          size: 1,
          value: 2,
          imageClass: "no-seat",
          imageURL: "",
        },
        {
          seatName: "Wheel Chair",
          size: 1,
          value: 3,
          imageClass: "wheelchair",
          imageURL: "",
        },
        {
          seatName: "VIP Seat",
          size: 1,
          value: 5,
          imageClass: "vip-seat",
          imageURL: "",
        },
        {
          seatName: "Only POS",
          size: 1,
          value: 9,
          imageClass: "pointofsale",
          imageURL: "",
        },
        {
          seatName: "Sofa",
          size: 1,
          value: 10,
          imageClass: "sofa-seat",
          imageURL: "",
        },
        {
          seatName: "Recliner",
          size: 1,
          value: 11,
          imageClass: "recliner",
          imageURL: "",
        },
        {
          seatName: "Broken Seat",
          size: 1,
          value: 13,
          imageClass: "broken-seat",
          imageURL: "",
        },
      ],
      seatsSelectedRateGroupNew: [],
      SELECTED_SEATS: [],
      totalAmountPrice: 0,
      totalNetAmout: 0,
      totalSeatBooked: 0,
      checkPopupExist: false,
      currencyData: {
        curr_code: "INR",
      },
      newSeatLayoutArray: [],
      rateCardGroup: [],
      selectedUser: "",
      Users: [],
      UsersCopy: [],
      user_id: "",
      searchUser: "",
      activeSeatTypes: [],
      // enablefetch: true,
      phoneNumber: "",
      emailId: "",
      firstName: "",
      isGuestDetail: true,
      isMarketingBulkTicket: "N",
      Remarks: "",
      isErrorGuest: false,
      ErrorGuest: "",
      CinemaObj: "",
      showTimeObj: "",
      paymentModes: [],
      selectedPaymentMode: null,
      seatBookedSummmary: [],
      seatBookedSummaryObj: {
        channel_name: null,
        channel_id: null,
        channel_color: null,
        booking_count: 0,
      },
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getAllActiveCinemas(obj);
    } else {
      this.getAllActiveCinemas(obj);
    }
    // this.getCountryList();
    // this.getAllActiveMovies();
    this.SetAllSeats = [];
    this.getCurrencyCode();
    this.getSeatTypes();
    this.GET_PAYMENT_MODES();
  },
  computed: {
    seatType() {
      return this.$store.getters.SEAT_LAYOUT_DATA;
    },
    scheduleShowId() {
      return this.$store.getters.SCHEDULE_SHOW_ID;
    },
     showChannelWiseBookings() {
      return CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME && false;
    },
  },
  methods: {
     checkSeatPriortyColor(seat) {
      if(this.showChannelWiseBookings && seat.hasOwnProperty("booking_color") && seat['booking_color']) {
        return seat['booking_color']
      } else {
        return ''
      }
    },
    onSelectPaymentMode(mode, type) {
      if (type == "select") {
        this.selectedPaymentMode = mode;
        this.selected.pm_id = mode.pm_id;
      } else {
        this.selectedPaymentMode = "";
        this.selected.pm_id = null;
      }
    },
    GET_PAYMENT_MODES() {
      PosService.GetValidPaymentModes(1)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            if (data.Records && data.Records.length > 0) {
              this.paymentModes = data.Records;
              let tempPayMode = data.Records.filter((x) => x.pm_id == 1);
              if (tempPayMode && tempPayMode.length) {
                this.selectedPaymentMode = tempPayMode[0];
                this.selected.pm_id = tempPayMode[0].pm_id;
              }
            }
          } else {
            this.toasted.show(data.message);
          }
        })
        .catch((error) => {
          console.log("Error:", error);
        });
    },
    onSelectAllSeats(event, main_seat, seat_index) {
      console.log("onSelectAllSeats", event, main_seat, seat_index);
      this.seatType[seat_index].seatsFinal.forEach((seatRow, seatRowIndex) => {
        seatRow.forEach((singleSeat, singleSeatIndex) => {
          if (
            ![2, 3, 4, 5, 13, 12].includes(singleSeat.seat_reserve_type_id) &&
            ((event == "Y" &&
              !singleSeat.selectStatus &&
              singleSeat.seat_reserve_type_id != 8) ||
              (event == "N" &&
                singleSeat.seat_reserve_type_id == 8 &&
                singleSeat.selectStatus == true))
          ) {
            this.onClickSeat(
              singleSeat,
              seatRowIndex,
              singleSeatIndex,
              null,
              null,
              null,
              seat_index
            );
          }
        });
      });
    },
    seatsSelectedRateGroup() {
      let array = [];
      if (this.checkPopupExist == false) {
        console.log(" this.$store.getters.SELECTED_SEATS", this.SELECTED_SEATS);
        this.totalSeatBooked = 0;
        this.totalAmountPrice = 0;
        this.totalNetAmout = 0;
        this.totalSeatBooked = 0;
        let checkCheckoutRateCardNeeded = 0;
        if (this.SELECTED_SEATS.length > 0) {
          this.SELECTED_SEATS.map((x) => {
            let find_In = array.findIndex((new1) => {
              return new1.sst_id == x.sst_id;
            });
            if (find_In >= 0) {
              array[find_In]["AllSeats"].push(x);
              if (array[find_In]["rate_card_group"].length == 1) {
                array[find_In]["totalSelected"] =
                  array[find_In]["totalSelected"] + 1;
                array[find_In]["rate_card_group"][0].totalSeatSelected =
                  array[find_In]["rate_card_group"][0].totalSeatSelected + 1;
                // console.log(x.rc_total_amount, "test");
                this.totalAmountPrice =
                  parseFloat(this.totalAmountPrice) +
                  parseFloat(
                    array[find_In]["rate_card_group"][0].rc_total_amount
                  );
                this.totalNetAmout =
                  parseFloat(this.totalNetAmout) +
                  parseFloat(
                    array[find_In]["rate_card_group"][0].rc_net_amount
                  );
                this.totalSeatBooked = this.totalSeatBooked + 1;
              } else if (array[find_In]["rate_card_group"].length > 1) {
                checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
              }
            } else {
              let arrayCardGroup = [];
              x.rate_card_group.map((rg) => {
                rg["totalSeatSelected"] = 0;
                arrayCardGroup.push(rg);
              });
              console.log(x, "Seats");
              let obj = {
                srt_name: x.sst_seat_type,
                sst_id: x.sst_id,
                AllSeats: [x],
                totalSelected: 0,
                rate_card_group: arrayCardGroup,
              };
              if (arrayCardGroup.length == 1) {
                obj["totalSelected"] = 1;
                obj["rate_card_group"][0].totalSeatSelected = 1;
                this.totalAmountPrice =
                  parseFloat(this.totalAmountPrice) +
                  parseFloat(obj["rate_card_group"][0].rc_total_amount);
                this.totalNetAmout =
                  parseFloat(this.totalNetAmout) +
                  parseFloat(obj["rate_card_group"][0].rc_net_amount);
                this.totalSeatBooked = this.totalSeatBooked + 1;
              } else if (arrayCardGroup.length > 1) {
                checkCheckoutRateCardNeeded = checkCheckoutRateCardNeeded + 1;
              }

              array.push(obj);
            }
          });
          this.seatsSelectedRateGroupNew = array;
          console.log("RATE CARD GROUP", this.seatsSelectedRateGroupNew);
          console.log(array);
          return array;
        } else {
          this.seatsSelectedRateGroupNew = [];
        }
      } else {
      }
    },
    isEmailAddress(str) {
      // str = "azamsharp@gmail.com";

      let filter2 =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!filter2.test(str)) {
        return false;
      } else {
        return true;
      }
    },
    getCountryList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("data :", data);
            this.country_code = data.details[0].country_mob_code;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    checkAlreadyBlocked(seat) {
      if (seat.seat_reserve_type_id == 8 && !seat.selectStatus) {
        return false;
      } else if (seat.seat_reserve_type_id == 8 && seat.selectStatus == true) {
        return true;
      } else {
        return true;
      }
    },
    getSeatTypes: function (screen) {
      let payload = {
        tableName: "ms_seat_reserve_types",
        srt_is_active: "Y",
      };
      this.seatTypes = [];
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.activeSeatTypes = data.Records;
            this.activeSeatTypes.map((x) => {
              let obj = {
                seatName: x.srt_name,
                size: x.srt_seat_capacity,
                value: x.srt_id,
                imageClass: "regular-seat",
                imageURL: this._GetImagePath(x.srt_dash_image_url),
              };
              if (x.srt_id == 1) {
                this.seatTypeSelected = obj;
              }
              this.seatTypes.push(obj);
            });
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error :", error);
        });
    },
    getSeatIconURL(singleSeat) {
      let iconPath = ``;
      if (singleSeat.selectStatus) {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_selected);
      } else if (
        singleSeat.seat_reserve_type_id == 12 ||
        singleSeat.seat_reserve_type_id == 8
      ) {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_disabled);
      } else {
        iconPath = this._GetImagePath(singleSeat.srt_dash_image_url);
      }
      return iconPath;
    },
    onSelectUser: function (event, user) {
      this.selectedUser = user.first_name + " " + user.last_name;
      this.user_id = user.user_id;
      this.searchUser = "";
      this.onSearchUser();
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
          }
        })
        .catch((error) => {});
    },
    getUsersList: function (cinema_id) {
      // let body = this.getRequestBody("GET", undefined, {
      //   GET: "/admin/",
      //   tableName: "users"
      // });
      // if (cinema_id) {
      //   body[cinema_id] = cinema_id;
      // }
      MasterService.GetUsers({ cine_id: cinema_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Users = data.Records;
            this.UsersCopy = data.Records;
            this.Users = this.Users.filter((singleRole) => {
              // console.log('singleRole :', singleRole.role_id != 2);
              if (singleRole.role_id == 4 || singleRole.role_id == 8) {
                return singleRole;
              }
            });
            this.UsersCopy = this.UsersCopy.filter((singleRole) => {
              // console.log('singleRole :', singleRole.role_id != 2);
              if (singleRole.role_id == 4 || singleRole.role_id == 8) {
                return singleRole;
              }
            });
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onSearchUser: function () {
      if (this.searchUser && this.searchUser.length > 0) {
        this.Users = this.UsersCopy.filter((x) => {
          // let full_name = `${x.first_name} ${x.last_name}`
          if (
            x.first_name.toLowerCase().includes(this.searchUser.toLowerCase())
            // x.last_name.toLowerCase().includes(this.searchUser.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Users = this.UsersCopy;
      }
    },
    async totalCount(rg, index, rg_index, type) {
      let x =
        this.seatsSelectedRateGroupNew[index]["rate_card_group"][rg_index];

      if (
        type == "increment" &&
        this.seatsSelectedRateGroupNew[index].totalSelected ==
          this.seatsSelectedRateGroupNew[index].AllSeats.length
      ) {
        return false;
      }

      if (
        type == "increment" &&
        this.totalSeatBooked + 1 <= this.SELECTED_SEATS.length &&
        x["totalSeatSelected"] <= this.SELECTED_SEATS.length
      ) {
        x["totalSeatSelected"] = x["totalSeatSelected"] + 1;
        this.seatsSelectedRateGroupNew[index].totalSelected =
          this.seatsSelectedRateGroupNew[index].totalSelected + 1;
      } else if (
        this.seatsSelectedRateGroupNew[index].totalSelected >= 1 &&
        type == "decrement" &&
        x["totalSeatSelected"] >= 1
      ) {
        x["totalSeatSelected"] = x["totalSeatSelected"] - 1;
        this.seatsSelectedRateGroupNew[index].totalSelected =
          this.seatsSelectedRateGroupNew[index].totalSelected - 1;
      }

      let totalAmount = 0;
      let totalSeatBooked2 = 0;
      let totalNetAmout2 = 0;
      this.seatsSelectedRateGroupNew.map((z) => {
        z.rate_card_group.map((y) => {
          totalAmount =
            parseFloat(totalAmount) +
            parseFloat(y.totalSeatSelected) * parseFloat(y.rc_total_amount);

          totalNetAmout2 =
            parseFloat(totalNetAmout2) +
            parseFloat(y.totalSeatSelected) * parseFloat(y.rc_net_amount);
        });

        totalSeatBooked2 =
          parseInt(totalSeatBooked2) + parseInt(z.totalSelected);
      });
      this.totalAmountPrice = totalAmount;
      this.totalSeatBooked = totalSeatBooked2;
      this.totalNetAmout = totalNetAmout2;
      x["tt_name"] = x["tt_name"] + " ";
      if (totalSeatBooked2 == this.SELECTED_SEATS.length) {
        // this.$store.dispatch("onSetCompleteRateCard", {
        //   status: true,
        //   seatGroup: this.seatsSelectedRateGroupNew,
        // });
        // this.$store.dispatch("onSetCompleteNewTotalAmount", {
        //   totalAmount: this.totalAmountPrice,
        //   netAmount: this.totalNetAmout,
        // });
      }
      console.log("fdsfdsfdsf");
    },
    onSearchMovie: function () {
      if (this.searchMovie && this.searchMovie.length > 0) {
        this.MoviesList = this.MoviesListCopy.filter((x) => {
          if (
            x.movie_title.toLowerCase().includes(this.searchMovie.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.MoviesList = this.MoviesListCopy;
      }
    },
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.CinemasList = this.CinemasListCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.CinemasList = this.CinemasListCopy;
      }
    },
    ResetForm: function () {
      this.btenable = false;
      this.submitted = false;
      this.selected.cinema = "";
      this.selected.screen_name = "";
      this.selected.movie_name = "";
      this.showdate = "";
      this.selected.show_time = "";
      this.flag = false;
      this.isMarketingBulkTicket = "N";
      this.SetAllSeats = [];
      // this.seatType = "";
    },
    clearSelectedDate: function () {
      this.showdate = "";
    },
    onCopyId(id) {
      this.$copyText(id).then((e) => {
        if (e.action === "copy") {
          this.$toasted.show("Reservation Id Copied");
        } else {
          this.$toasted.show("Cannot Copy Reservation Id");
        }
      });
    },
    onchangeStartDate: _.debounce(function (query) {
      this.getshowtimebyMovie();
      this.SetAllSeats = [];
      this.flag = false;
      this.resetList();
    }, 0.5 * 1000),
    getshowtimebyMovie: function () {
      if (!this.showdate) {
        return;
      }
      this.ShowTime = [];
      this.showTimeObj = "";
      this.selected.show_time = "";
      this.ss_id = "";
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.cineid,
        // screen: this.screenid,
        // movie: this.movieid,
        ss_actual_start_date: moment(this.showdate).format("YYYY-MM-DD"),
        isPastBooking: "Y",
      };
      // console.log("payload :", payload);

      scheduleService.GetScheduleByDate(payload).then((response) => {
        console.log("response :", response);
        const { data } = response;
        loader.hide();
        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.ShowTime = data.Records;
          } else {
            this.$toasted.show(`No Shows Found for this ${this.showdate}`);
          }
        } else {
          this.$toasted.show(`No Shows Found for this ${this.showdate} `);
        }
      });
    },
    getAllActiveCinemas: function (cine_id) {
      //  let payload = null
      // cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasList = data.Records;
            this.CinemasListCopy = data.Records;
            this.CinemasList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selected.cinema = x.cine_name;
                let cinema = {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                };
                this.onSelectCinema(event, cinema);
              }
            });

            let Operation_country_id = (
              this.$store.getters.getGlobalOptions || []
            ).filter((z) => {
              return z.go_key == "OPERATION_COUNTRY";
            });
            if (Operation_country_id.length) {
              this.getCountryList(Operation_country_id[0].go_value);
            }
            console.log(Operation_country_id, "getGlobalOptions");
          } else {
            // Show Error message
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveCinemas :", error);
        });
    },
    onSelectCinema: function (cinema) {
      this.selected.cinema = cinema.cine_name;
      this.cineid = cinema.cine_id;
      this.dateenable = false;
      // this.getAllActiveScreens(cinema.cine_id);
      this.getUsersList(cinema.cine_id);
      this.searchCinema = "";
      this.onSearchCinema(null);

      this.selected.screen_name = "";
      this.screenid = "";
      this.movieenable = true;
      this.selected.movie_name = "";
      this.movieid = "";
      this.showdate = "";
      this.selected.show_time = "";
      this.showid = "";
      this.turnOffMultiSeatSelection = "N";
      this.ShowTime = [];
      this.flag = false;
      this.submitted = false;
      this.SetAllSeats = [];
      this.selectedUser = "";
      this.getShowDateByCinema();
    },
    getShowDateByCinema() {},
    getAllActiveScreens: function (cinema_id) {
      // console.log("cinema_id :", cinema_id);
      this.ScreenList = [];
      let payload = {
        cinema_id: cinema_id,
      };

      scheduleService
        .GetScreens(payload)
        .then((response) => {
          const { data } = response;
          console.log("data :", data);
          if (data && data.status && data.Records.length > 0) {
            this.ScreenList = data.Records.filter(
              (x) => x.screen_seat_types.length > 0
            );
            this.ScreenList.map((x) => {
              this.selectedMoviesInScreens.push({
                ...x,
                movies: [],
              });
            });
          } else {
            // Show Message Here:
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveScreens :", error);
        });
    },
    onSelectScreen: function (event, screen, screenindex) {
      // console.log("screen :", screen, screenindex);
      this.selected.screen_name = screen.screen_name;
      this.screenid = screen.screen_id;
      // this.movieenable = false;

      // this.selected.movie_name = "";
      // this.movieid = "";
      // this.showdate = "";
      // this.selected.show_time = "";
      // this.showid = "";
      // this.turnOffMultiSeatSelection = "N";
      // this.ShowTime = [];
      // this.flag = false;
      // this.SetAllSeats = [];
      // this.submitted = false;
    },
    onSelectScreenNew: function (screen) {
      this.selected.screen_name = screen.screen_name;
      this.screenid = screen.screen_id;
    },
    getAllActiveMovies: function () {
      scheduleService
        .GetMovies()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.MovieListResult.length > 0) {
            this.MoviesList = data.MovieListResult;
            this.MoviesListCopy = data.MovieListResult;
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error on getAllActiveMovies :", error);
        });
    },
    onSelectMovie: function (event, movie) {
      this.selected.movie_name = movie.movie_name;
      this.movieid = movie.md_id;
      this.dateenable = false;
      this.searchMovie = "";

      this.showdate = "";
      this.selected.show_time = "";
      this.showid = "";
      this.turnOffMultiSeatSelection = "N";
      this.ShowTime = [];
      this.flag = false;
      this.SetAllSeats = [];
      this.submitted = false;
      this.onSearchMovie();
    },
    onSelectMovieNew(movie) {
      this.selected.movie_name = movie.movie_name;
      this.movieid = movie.md_id;
    },
    onSelectShow: function (show) {
      this.selected.show_time = show.ss_start_show_time;
      this.showid = show.ss_id;
      this.turnOffMultiSeatSelection = "N";
      this.onSelectScreenNew(show);
      this.onSelectMovieNew(show);
      // this.enablefetch = false;
    },
    onFinalSubmit: function () {
      this.submitted = true;
      this.resetList();
      this.SetAllSeats = [];

      if (this.selected.cinema.length == 0) {
        this.msgcinema = "Please Select Cinema.";
        return;
      } else if (this.selected.show_time.length == 0) {
        this.msgshowtime = "Please select Show Time";
        return;
      } else if (this.selected.screen_name.length == 0) {
        this.msgscreen = "Please Select Screen.";
        return;
      } else if (this.selected.movie_name.length == 0) {
        this.msgmovie = "Please Select Movie.";
        return;
      } else if (this.selectedUser.length == 0 && !this.selectedUser) {
        this.messageuser = "Please select  User";
        return;
      } else {
        this.btenable = false;
        let loader = this.$loading.show();
        this.$validator.validate().then(async (valid) => {
          if (valid) {
            this.btenable = true;
            let data = {};

            let seats = await PosService.PosGetSeatLayout({
              screen_id: this.screenid,
              ss_id: this.showid,
              md_id: this.movieid,
            });
            data.seats = seats.data;

            let seatType = await PosService.getSeatType({
              screen_id: this.screenid,
              ss_id: this.showid,
              md_id: this.movieid,
            });

            loader.hide();
            data.seatType = seatType.data;

            if (seats && seats.status) {
              this.btenable = false;
              this.flag = true;
              this.$store.dispatch("GET_Reserve_SEAT_LAYOUT", data);
              if(this.showChannelWiseBookings) {
              let actualSeats = data.seats.Records.filter((_seat) => !['2','12','13'].includes(String(_seat.seat_reserve_type_id)))
              let groupRecords = _.groupBy(actualSeats, "booking_channel_id");
              if(Object.keys(groupRecords).length) {
                Object.keys(groupRecords).map((key) => {
                  let tempObj = {
                    channel_name: groupRecords[key].length ? groupRecords[key][0]['booking_channel'] || 'Available' : '',
                    channel_id: groupRecords[key].length ? groupRecords[key][0]['booking_channel_id'] : '',
                    channel_color: groupRecords[key].length ? groupRecords[key][0]['booking_color'] : '',
                    booking_count: parseInt(groupRecords[key].length || 0)
                  }
                  this.seatBookedSummmary.push(tempObj)
                })
              }
            }
            } else {
              this.btenable = false;
              vue.toasted.show(data.message || "Please try later");
            }
          }
        });
      }
    },

    selectSeatType: function (seatType) {
      console.log(seatType);
      this.seatTypeSelected = seatType;
      this.seatTypeSelectionMode = "seatType";
    },
    resetList() {
      this.$refs.showRateCardPrice.hide();
      this.seatsSelectedRateGroupNew = [];
      this.SELECTED_SEATS = [];
      this.isMarketingBulkTicket = "N";
      this.totalAmountPrice = 0;
      this.totalNetAmout = 0;
      this.totalSeatBooked = 0;
      this.checkPopupExist = false;
      this.newSeatLayoutArray = [];
      this.rateCardGroup = [];
      this.guestDetailData = [];
      this.isGuestDetail = true;
      this.Remarks = "";
      this.$forceUpdate();
    },

    async checkGuestAndInsertGuest() {
      let status = true;
      let message = ``;

      return new Promise(async (resolve) => {
        if (!this.firstName) {
          message = "Please Enter Name";
          status = false;
        }
        if (!this.emailId && status) {
          message = "Please Enter Email Id";
          status = false;
        }

        if (!this.isEmailAddress(this.emailId) && status) {
          message = "Please Enter Valid  Email Id";
          status = false;
        }

        if (!this.phoneNumber && status) {
          message = "Please Enter Phone Number";
          status = false;
        }
        if (String(this.phoneNumber).length < 8 && status) {
          message = "Please Enter Valid Phone Number";
          status = false;
        }

        if (status) {
          let guest_detail = {
            guest_email: this.emailId,
            guest_first_name: this.firstName.split(" ")[0],
            guest_last_name: this.firstName.split(" ")[1]
              ? this.firstName.split(" ")[1]
              : "-",
            guest_mobile: this.phoneNumber,
            guest_country_code: this.country_code,
            guest_user_id: Math.floor(100000000 + Math.random() * 900000000),
            isUpdateLang: false,
            selected_lang_id: 1,
          };

          MasterService.onGuestDetails(guest_detail).then((res) => {
            const { data } = res;
            if (data.status && data.data && data.data.length) {
              this.guestDetailData = data.data;
              return resolve({
                status,
                message,
              });
            }
          });
        } else {
          return resolve({
            status,
            message,
          });
        }
      });
    },

    async reserveSeats() {
      if (this.isGuestDetail) {
        let checkGuest = await this.checkGuestAndInsertGuest();
        if (!checkGuest.status) {
          this.isErrorGuest = true;
          this.ErrorGuest = checkGuest.message;
          return;
        }
      }
      this.isErrorGuest = false;
      this.ErrorGuest = "";

      console.log(this.guestDetailData);

      this.newSeatLayoutArray = [];
      this.rateCardGroup = [];
      this.seatLayoutArrayArrange(this.seatsSelectedRateGroupNew);
      let seatLayout_id_array = [];

      let seat_type_id_array = [];
      this.SELECTED_SEATS.map((x) => {
        seatLayout_id_array.push(x.sl_id);
        seat_type_id_array.push(x.sst_id);
      });
      let transactionDateTime = moment(
        moment(this.showdate).format("YYYY-MM-DD") +
          " " +
          this.selected.show_time
      ).format("YYYY-MM-DD HH:mm:ss");
      let payload = {
        cinema_id: this.cineid,
        payment_mode_id: this.selected.pm_id || null,
        payment_modes: this.selectedPaymentMode || null,
        seat_layout_id: seatLayout_id_array,
        seat_type_id: seat_type_id_array,
        newSeatLayout: this.newSeatLayoutArray,
        schedule_show_id: this.showid,
        reservation_id: Math.floor(100000000 + Math.random() * 900000000),
        isVipOrBlockSeats: false,
        isMarketingBulkTicket: this.isMarketingBulkTicket || "N",
        groupRateCard: true,
        isPos: true,
        func: 5,
        PastBooking: true,
        PosUserId: this.user_id,
        transactionDateTime: transactionDateTime,
        is_guest_user: "N",
        guest_details: {
          guest_email: "",
          guest_user_id: "",
          guest_mobile: "",
          guest_country_code: "",
        },
        comment: this.Remarks,
      };

      if (this.isGuestDetail) {
        payload["guest_details"] = {
          ...this.guestDetailData[0],
        };
        payload["is_guest_user"] = "Y";
      }
      let loader = this.$loading.show();
      PosService.PosReserveSeat(payload)
        .then((response) => {
          const { data } = response;

          console.log(data, "fsddfsdf233");
          if (data.status) {
            this.resetList();
            setTimeout(() => {
              this.$toasted.show(data.message);
              loader.hide();
              this.onFinalSubmit();
            }, 2000);
            // vue.toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
            loader.hide();
          }
        })
        .catch((err) => {
          console.log("Error", err);
          this.$toasted.show("Catch error in reserve seat");
          loader.hide();
        });
    },
    onClickSeat(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
      let self = this;
      if ([2, 12, 13].includes(seat.seat_reserve_type_id)) {
        this.$toasted.show("Not Available");
        return false;
      } else if (
        seat.srt_multi_select == "Y" &&
        this.turnOffMultiSeatSelection != "Y" &&
        seat.sl_group_id
      ) {
        let groupSeatsIndexes = [];
        groupSeatsIndexes = this.seatType[type].seatsFinal[rowIndex].reduce(
          function (a, e, i) {
            if (
              e.sl_group_id == seat.sl_group_id &&
              ![2, 12, 13].includes(e.seat_reserve_type_id) &&
              self.checkAlreadyBlocked(e)
            )
              a.push(i);
            return Array.from(new Set(a));
          },
          []
        );

        console.log("groupSeatsIndexes", groupSeatsIndexes);

        if (groupSeatsIndexes && groupSeatsIndexes.length > 0) {
          for (let i = 0; i < groupSeatsIndexes.length; i++) {
            this.handlerSeatSelected(
              this.seatType[type].seatsFinal[rowIndex][groupSeatsIndexes[i]],
              rowIndex,
              groupSeatsIndexes[i],
              originalIndex,
              backward,
              e,
              type
            );
          }
        }
      } else {
        this.handlerSeatSelected(
          seat,
          rowIndex,
          seatIndex,
          originalIndex,
          backward,
          e,
          type
        );
      }
    },

    handlerSeatSelected: function (
      seat,
      rowIndex,
      seatIndex,
      originalIndex,
      backward,
      e,
      type
    ) {
      console.log(seat, "fsdfds");

      // this.SetAllSeats = [];
      seat.seatIndex = seatIndex;
      seat.rowIndex = rowIndex;

      let selectedIndex = this.SetAllSeats.findIndex(
        (x) => String(x.seat.sl_id) === String(seat.sl_id)
      );

      let selectedIndexNew = this.SELECTED_SEATS.findIndex(
        (seat1) => String(seat1.sl_id) === String(seat.sl_id)
      );

      console.log(selectedIndexNew, "selectedIndexNew");
      if (selectedIndex !== -1) {
        this.SetAllSeats.splice(selectedIndex, 1);
        this.SELECTED_SEATS.splice(selectedIndexNew, 1);
        this.$store.dispatch("SEAT_SELECTION_FALSE", {
          seat: seat,
          seattype: this.seatTypeSelected,
        });

        this.$forceUpdate();
      } else {
        this.SELECTED_SEATS.push(seat);
        this.SetAllSeats.push({
          rowIndex,
          seatIndex,
          originalIndex,
          backward,
          type,
          seat: seat,
        });
        this.$store.dispatch("SEAT_SELECTION_TRUE", {
          seat: seat,
          seattype: this.seatTypeSelected,
        });
      }
      this.$forceUpdate();

      console.log(
        this.SELECTED_SEATS.length,
        this.SELECTED_SEATS,
        "this.SELECTED_SEATS22222"
      );
      this.seatsSelectedRateGroup();
    },
    simpleStringify(object) {
      var simpleObject = {};
      for (var prop in object) {
        if (!object.hasOwnProperty(prop)) {
          continue;
        }
        if (typeof object[prop] == "object") {
          continue;
        }
        if (typeof object[prop] == "function") {
          continue;
        }
        simpleObject[prop] = object[prop];
      }
      return simpleObject; // returns cleaned up JSON
    },

    seatLayoutArrayArrange(seatGroup) {
      seatGroup.map((seat_g) => {
        seat_g.rate_card_group.map((rg) => {
          let findIndex32 = this.rateCardGroup.findIndex((newrg) => {
            return newrg.tt_id == rg.tt_id;
          });

          if (findIndex32 >= 0) {
            this.rateCardGroup[findIndex32]["count"] =
              this.rateCardGroup[findIndex32]["count"] + rg.totalSeatSelected;
          } else {
            let objRateCard = {
              tt_id: rg.tt_id,
              tt_name: rg.tt_name.trim(),
              count: rg.totalSeatSelected,
            };
            this.rateCardGroup.push(objRateCard);
          }

          for (let i = 0; i < rg.totalSeatSelected; i++) {
            let obj = {
              rate_card_id: rg.rate_card_id,
              tt_id: rg.tt_id,
              rc_g_id: rg.rc_g_id,
              rcg_c_id: rg.rcg_c_id,
              tt_name: rg.tt_name,
              seat_type_id: seat_g.sst_id,
              status: false,
            };

            this.newSeatLayoutArray.push(obj);
          }
        });
      });
    },

    OnSave: async function () {
      this.$refs.showRateCardPrice.show();
      return false;

      if (this.SetAllSeats.length > 0) {
        let arraySeats = [];
        this.SetAllSeats.map((x) => {
          let obj = this.simpleStringify(x.seat);
          x["seat"] = obj;
          arraySeats.push(x);
        });
        console.log(arraySeats);
        console.log(this.SetAllSeats, "dsfsd");
        return false;
        this.reservation_id = null;
        let payload = {
          cine_id: this.cineid,
          screen_id: this.screenid,
          schedule_show_id: this.showid,
          movie_id: this.movieid,
          allSeats: arraySeats,
        };

        console.log(payload, "sdfds");
        ExhibitorService.ReserveSeat(payload).then(async (response) => {
          console.log("response", response);
          const { data } = response;
          if (data && data.status) {
            // this.$toasted.show(data.message);
            this.reservation_id = data.reservation_id || null;
            this.$refs["reservation_id_popup"].show();
            await this.ResetForm();
          } else {
            this.$toasted.show(data.message);
          }
        });
      } else {
        this.$toasted.show("Please select at least one reserve seat.");
      }
      // this.SetAllSeats.map(x => {
      //   this.$store.dispatch("SEAT_SELECTION", {
      //     seat: x.seat,
      //     seatIndex: x.seatIndex,
      //     rowIndex: x.rowIndex,
      //     classIndex: x.type,
      //     scheduleShowId: this.scheduleShowId
      //   });
      // });

      // console.log("this. :", this.seatType);
    },
  },
};
</script>

<style>
.grey {
  background-color: lightgray;
}
.reserve-seat-layout {
  margin: 0 auto;
}
.normal-seat {
  display: none !important;
}

.reserve-seat-layout td {
  padding: 5px;
}
.reserve-seat-layout .cinema-seat {
  background-color: var(--blue);
}
.fs-22 {
  font-size: 22px;
}
</style>

<style>
/*@media (min-width: 992px) {*/

/* .seat_select_modal .modal-lg{*/
/*  max-width: 1030px;*/
/*  background-color: white;*/
/*  } */

/*}*/

.seat-type {
  padding: 1rem;
  min-width: 200px;
  height: 115px;
  font-weight: bold;
}

#showRateCardPrice .seat-type {
  width: 280px !important;
}

.seat-type.gold {
  background-color: #fcf4d9;
  color: #f2c94c;
}

.seat-type.silver {
  background-color: #efefef;
  color: #a8a8a8;
}

.seat-type .st-name {
  font-weight: bold;
  font-size: 2.5rem;
  border-bottom: 1px solid #bfbfbf;
  line-height: 1;
  margin-bottom: 0.25rem;
  word-break: break-all;
}
#showRateCardPrice .category {
  width: 240px !important;
}

#showRateCardPrice .category .category-name {
  word-break: break-all;
}
.category {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 130px;
  background-color: #efefef;
  color: black;
  text-align: center;
  margin: 1rem;
  border-radius: 0.5rem;
}
.category.disabled {
  background-color: #f9f9f9;
  color: #999999;
}
.category.disabled .mod-btn {
  background-color: #afc8ed;
}
.category .category-name {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.category .category-price {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.category .category-seats {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: 1px solid #bfbfbf;
  padding: 0.25rem;
  width: 100%;
  color: black;
  user-select: none;
}
.category .category-seats .mod-btn {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  color: white;
  background-color: #3876d2;
  height: 40px;
  width: 40px;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.4s;
}
.category .category-seats .mod-btn:hover {
  color: #3876d2;
  background-color: white;
}
.category .category-seats .mod-btn:active,
.category .category-seats .mod-btn.active {
  transform: scale(0.8);
}

.category .category-seats .mod-btn.disabled,
.btn-submit-disabled {
  background-color: lightgrey;
  pointer-events: none;
}

.fl.btn-blue {
  font-size: 20px !important;
  padding: 1.5rem 2rem;
}

.currency-symbol {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 12px;
  transform: translateY(-50%);
}
.InputAmount {
  padding-right: 3rem !important;
}
.text-error {
  color: red !important;
}
#showRateCardPrice___BV_modal_content_ {
  zoom: 0.8;
}

.channel-box {
    display: flex;
    margin-right: 20px;
}

.colorNote {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  border: 1px solid;
}

.channelNote {
  margin-inline: 5px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ReserveSeatComponent/pastBooking.vue